function IconShop() {
  return (
    <div className="flex justify-center">
      <div className="text-4xl font-bold">아이콘샵 개발중</div>
    </div>
  );
}

export default IconShop;
